import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Outlets = Loadable(lazy(() => import('./Outlet/Outlet')));
const Banks = Loadable(lazy(() => import('./Bank/Bank')));

const stockRoutes = [
    { path: '/account-master/debtors',  element: <Outlets />, auth: authRoles.admin },  
    { path: '/account-master/debtors/:id',  element: <Outlets />, auth: authRoles.admin },  
    { path: '/account-master/bank',  element: <Banks />, auth: authRoles.admin },  
    { path: '/account-master/bank/:id',  element: <Banks />, auth: authRoles.admin }
];

export default stockRoutes;